import api from './api';

export const invoiceService = {
  async getInvoices(params = {}) {
    const response = await api.get('/invoices', { params });
    return response.data;
  },
  
  async getInvoice(id) {
    const response = await api.get(`/invoices/${id}`);
    return response.data.data;
  },
  
  async createInvoice(data) {
    const response = await api.post('/invoices', data);
    return response.data.data;
  },
  
  async updateInvoice(id, data) {
    const response = await api.patch(`/invoices/${id}`, data);
    return response.data.data;
  },
  
  async deleteInvoice(id) {
    const response = await api.delete(`/invoices/${id}`);
    return response.data;
  },
  
  async sendInvoice(id) {
    const response = await api.post(`/invoices/${id}/send`);
    return response.data.data;
  },
  
  async addPayment(id, data) {
    const response = await api.post(`/invoices/${id}/payments`, data);
    return response.data.data;
  },
  
  async markAsPaid(id, method = 'other') {
    const response = await api.post(`/invoices/${id}/mark-paid`, { method });
    return response.data.data;
  },
  
  async cancelInvoice(id) {
    const response = await api.post(`/invoices/${id}/cancel`);
    return response.data.data;
  },
  
  async getStats() {
    const response = await api.get('/invoices/stats');
    return response.data.data;
  },
  
  async getExpenses(params = {}) {
    const response = await api.get('/invoices/expenses/list', { params });
    return response.data;
  },
  
  async createExpense(data, receipt = null) {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });
    if (receipt) {
      formData.append('receipt', receipt);
    }
    
    const response = await api.post('/invoices/expenses', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data.data;
  },
  
  async updateExpense(id, data) {
    const response = await api.patch(`/invoices/expenses/${id}`, data);
    return response.data.data;
  },
  
  async deleteExpense(id) {
    const response = await api.delete(`/invoices/expenses/${id}`);
    return response.data;
  }
};
